import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as fabricCanvasActions from '../../../redux/fabricCanvasActions';
import * as sideBarActions from '../../../redux/sideBarActions';
import { bindActionCreators } from 'redux';
import { Modal } from 'reactstrap';
import './FolderAuthentication.scss';
import { string } from '../../../localization';
import * as Constants from '../../../utilities/constants/Constants';

class FolderAuthentication extends Component {
  state = {
    password: '',
    handleErrorMessage: false
  };

  handlePasswordChange = value => {
    this.setState({ password: value });
  };

  handleErrorMessage = state => {
    this.setState({ handleErrorMessage: state });
  };

  handleClose = () => {
    const { authenticationWindowHandler } = this.props;
    authenticationWindowHandler(false);
    this.handleErrorMessage(false);
  };

  sendRequestForAuthentication = () => {
    const {
      dispatchers,
      storeId,
      item,
      isSubtheme,
      authenticationWindowHandler
    } = this.props;
    const { password } = this.state;

    dispatchers.sideBarActions.unlockFolderRequest(
      password,
      storeId,
      item,
      isSubtheme,
      authenticationWindowHandler,
      this.handleErrorMessage
    );
  };

  keyPress = e => {
    if (e.keyCode === Constants.ENTER_KEY_CODE) {
      this.sendRequestForAuthentication();
    }
  };

  render() {
    const { isOpen } = this.props;
    const { handleErrorMessage } = this.state;
    return (
      <Modal
        isOpen={isOpen}
        className='folder-authentication'
        modalClassName='folder-authentication-modal'
        backdropClassName='folder-authentication-backdrop'
      >
        <div className='body'>
          <div className='d-flex'>{string.AUTHENTICATE_DIALOG_TITLE}</div>
          <div className='password'>
            <input
              onChange={e => this.handlePasswordChange(e.target.value)}
              onKeyDown={e => this.keyPress(e)}
              type='password'
              placeholder='Password'
            />
          </div>
          <div className='d-flex justify-content-end'>
            {handleErrorMessage ? (
              <div className='errorMessage'>
                {string.AUTHENTICATE_FAILED_MESSAGE}
              </div>
            ) : null}
            <div
              role='button'
              tabIndex='0'
              className='button cancel-button'
              onKeyPress={() => {}}
              onClick={() => this.handleClose()}
            >
              {string.CANCEL_TEXT_KEY}
            </div>
            <div
              role='button'
              tabIndex='0'
              className='button ok-button'
              onKeyPress={() => {}}
              onClick={() => this.sendRequestForAuthentication()}
            >
              {string.OK_KEY}
            </div>
          </div>
        </div>
      </Modal>
    );
  }
}

function mapStateToProps(state) {
  return {
    storeId: state.modal.storeData.id
  };
}

function mapDispatchToProps(dispatch) {
  return {
    dispatchers: {
      fabricCanvasActions: bindActionCreators(fabricCanvasActions, dispatch),
      sideBarActions: bindActionCreators(sideBarActions, dispatch)
    }
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(FolderAuthentication);
